import { useMemo } from "react";

import classNames from "classnames";

import { UiMinusIcon } from "@jti/brand-icons/ui-minus";
import { UiPlusIcon } from "@jti/brand-icons/ui-plus";

import type { FooterNavLink } from "../../../types/FooterNavLink.type";
import { FooterNavLinks } from "../../FooterNavLinks";

import styles from "./FooterNavSection.module.scss";

export type FooterNavSectionProps = {
  title: string;
  links: FooterNavLink[];
  isCollapsible?: boolean;
  openedSection?: string[];
  onSectionClick?: (title: string) => void;
  multipleColumnList?: boolean;
  rowSize?: number;
  listClassName?: string;
  itemClassName?: string;
  openAssetsInNewTab?: boolean;
  withdrawalModalTriggerUrl?: string;
  onOpenWithdrawalModal?: () => void;
};

export const FooterNavSection = ({
  title,
  links,
  isCollapsible,
  openedSection,
  onSectionClick,
  multipleColumnList,
  rowSize,
  listClassName,
  itemClassName,
  openAssetsInNewTab,
  withdrawalModalTriggerUrl,
  onOpenWithdrawalModal,
}: FooterNavSectionProps) => {
  const showLinks = useMemo(() => {
    if (!isCollapsible) return true;
    return openedSection?.includes(title);
  }, [isCollapsible, openedSection, title]);

  const handleToggle = () => onSectionClick?.(title);

  return (
    <div className={styles.footerNavList}>
      <div className={styles.titleContainer}>
        <h4 className={styles.title}>{title}</h4>
        {isCollapsible && (
          <button
            onClick={handleToggle}
            className={styles.collapsibleButton}
            title="toggleSectionButton"
            data-testid="collapsibleButton"
          >
            {showLinks ? (
              <UiMinusIcon className={styles.collapsibleButtonIcon} />
            ) : (
              <UiPlusIcon className={styles.collapsibleButtonIcon} />
            )}
          </button>
        )}
      </div>
      <FooterNavLinks
        className={classNames(styles.subList, listClassName, {
          [styles.collapseList]: !showLinks,
          [styles.multipleColumnList]: multipleColumnList,
        })}
        itemClassname={itemClassName}
        listStyle={{ "--row-size": rowSize }}
        links={links}
        openAssetsInNewTab={openAssetsInNewTab}
        withdrawalModalTriggerUrl={withdrawalModalTriggerUrl}
        onOpenWithdrawalModal={onOpenWithdrawalModal}
      />
    </div>
  );
};
